import type {
    SelectionControlRadioTargetConstantType,
    SelectionControlRadioStepConstantType
} from "./type";
import {
    getHorizontalStep
} from "../../helpers/direction";

export const SELECTION_CONTROL_RADIO_GROUP_SELECTOR = "[role=\"radiogroup\"]";

export const SELECTION_CONTROL_RADIO_SELECTOR = "[role=\"radio\"][data-ncore-radio]";

export const SELECTION_CONTROL_RADIO_DATA_KEY = "ncoreRadio";

const SELECTION_CONTROL_RADIO_VERTICAL_STEPS: Record<string, number> = {
    ArrowDown: 1,
    ArrowUp: -1
};

export const getSelectionControlElement = (node: unknown): HTMLElement | null => {
    if(typeof HTMLElement === "undefined" || !(node instanceof HTMLElement)) {
        return null;
    }

    return node;
};

export const getSelectionControlRadioGroup = (radio: HTMLElement): HTMLElement | null => {
    return radio.closest<HTMLElement>(SELECTION_CONTROL_RADIO_GROUP_SELECTOR);
};

export const getSelectionControlRadios = (group: HTMLElement): Array<HTMLElement> => {
    return Array.from(group.querySelectorAll<HTMLElement>(SELECTION_CONTROL_RADIO_SELECTOR)).filter((radio) => {
        return radio.closest(SELECTION_CONTROL_RADIO_GROUP_SELECTOR) === group && radio.getAttribute("aria-disabled") !== "true";
    });
};

export const syncSelectionControlRadioGroup = (group: HTMLElement) => {
    const radios = getSelectionControlRadios(group);

    const tabStop = radios.find((radio) => radio.getAttribute("aria-checked") === "true") ?? radios[0];

    radios.forEach((radio) => {
        radio.tabIndex = radio === tabStop ? 0 : -1;
    });
};

export const getSelectionControlRadioStep = ({
    direction,
    key
}: SelectionControlRadioStepConstantType): number => {
    return SELECTION_CONTROL_RADIO_VERTICAL_STEPS[key] ?? getHorizontalStep({
        direction,
        key
    });
};

export const getSelectionControlRadioTarget = ({
    current,
    radios,
    step
}: SelectionControlRadioTargetConstantType): HTMLElement | undefined => {
    const index = radios.indexOf(current);

    if(index < 0) {
        return undefined;
    }

    for(let offset = 1; offset < radios.length; offset++) {
        const radio = radios[((index + step * offset) % radios.length + radios.length) % radios.length];

        if(radio && radio.getAttribute("aria-busy") !== "true") {
            return radio;
        }
    }

    return undefined;
};
